document.addEventListener("DOMContentLoaded", function () {
  const checkbox = document.getElementById("themeToggle");
  const prefersDarkScheme = window.matchMedia("(prefers-color-scheme: dark)");
  let isUpdatingProgrammatically = false;

  // Inicializar tema
  function initializeTheme() {
    const savedTheme = localStorage.getItem("theme");
    const isDark = prefersDarkScheme.matches;
    if (savedTheme) {
      document.body.classList.add(savedTheme);
      checkbox.checked = savedTheme === "dark-mode";
    } else {
      document.body.classList.add(isDark ? "dark-mode" : "light-mode");
      checkbox.checked = isDark;
    }
  }

  // Manejar cambio manual del interruptor
  checkbox.addEventListener("change", function () {
    if (isUpdatingProgrammatically) return;
    const newTheme = this.checked ? "dark-mode" : "light-mode";
    document.body.classList.remove("light-mode", "dark-mode");
    document.body.classList.add(newTheme);
    localStorage.setItem("theme", newTheme);
  });

  // Actualizar si el sistema cambia durante navegación
  prefersDarkScheme.addEventListener("change", function () {
    isUpdatingProgrammatically = true;
    const newTheme = this.matches ? "dark-mode" : "light-mode";
    document.body.classList.remove("light-mode", "dark-mode");
    document.body.classList.add(newTheme);
    localStorage.setItem("theme", newTheme);
    checkbox.checked = this.matches;
    setTimeout(() => { isUpdatingProgrammatically = false; }, 50);
  });

  initializeTheme();
});